// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormWrapper[data-v-c0f4b254]{--form-wrapper-gap: 1.5rem;display:flex;flex-direction:column;gap:var(--form-wrapper-gap)}\n", ""]);
// Exports
module.exports = exports;
